import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import {Observable} from "rxjs";
import { EventService } from '../services/event.service';
import {first, map} from "rxjs/operators";

export const EmailTemplatesResolver: ResolveFn<any> = ( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ) : Observable<any>|Promise<any>|any => {

    const eventService = inject(EventService);

    const getAdoptedEventId = function() {
        return eventService.selectedEvent.gql.Participant[0].adoptedEvent.adoptedEventId;
    }

    return eventService.getEmailTemplates(getAdoptedEventId())
        .pipe(map(res => res.AdoptedEvent[0].tieredEmailTemplates)
        ,first());
}
